<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="group_2 flex-col">
        <div class="image-wrapper_1 flex-row">
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngb1291def6e95f20aa925cd2a8b095b989ba8a940d5c37f8d02bbe287942f9277.png"
          />
        </div>
        <div class="text-wrapper_1 flex-row"><span class="text_1">支付&nbsp;¥20</span></div>
        <div class="box_1 flex-row">
          <div class="image-text_1 flex-col justify-between">
            <div class="group_3 flex-col">
              <div class="block_1 flex-col"><div class="box_2 flex-col"></div></div>
            </div>
            <span class="text-group_1">购买30天刷题会员</span>
          </div>
        </div>
        <div class="box_3 flex-row">
          <span class="text_2">支持</span>
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng5f415ea683b5ea3034ed4acf57defeb6a937311133a4d872b4a67af4d0729fe6.png"
          />
          <span class="text_3">扫码支付</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="scss" src="./assets/index.scss" />